import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card010SelfDetachmentObservation() {
  return <KbCardPage slug="card-010-self-detachment-observation" />;
}

(Card010SelfDetachmentObservation as unknown as { path: string }).path = "/methodology/010";
